import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://scarpbasestations.s3.ap-southeast-1.amazonaws.com'
  // baseURL: 'https://scarp-6d082-default-rtdb.firebaseio.com/'
  // baseURL: 'https://ggwy6ws6qvanlgyml53hxhglga.appsync-api.ap-northeast-1.amazonaws.com/graphql'
});

export default instance;
